import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/instoreLinkCard';

export const INSTORE_LINK_CARD_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const INSTORE_LINK_CARD_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
export const INSTORE_LINK_CARD_CLICK = `${rootActionPath}/CLICK`;
export const RESET_INSTORE_CARD_LINK_DATA = `${rootActionPath}/RESET_DATA`;
